/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：263
 */

"use strict"

var r
export { r as a };
(function (e) {
  e.ADD = "CLOUD_TABLE_ADD"
  e.SETTER = "CLOUD_TABLE_SETTER"
  e.DELETE = "CLOUD_TABLE_DELETE"
  e.QUERY = "CLOUD_TABLE_QUERY"
  e.CLEAR = "CLOUD_TABLE_CLEAR"
})(r || (r = {}))
export default r
